import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=e43dd18a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e43dd18a')) {
      api.createRecord('e43dd18a', component.options)
    } else {
      api.reload('e43dd18a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=e43dd18a&", function () {
      api.rerender('e43dd18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4PRIFhd3IBv0r/JS/cancellationPolicy.vue"
export default component.exports